<template>
<div >
    <h2>¿Cómo quieres pagar?</h2>
    <div class="payment-methods">
        <div class="payment-method">
            <div class="form-check">
                <input class="form-check-input" type="radio" name="paymentCards" id="paymentCards" v-model="payMethod" value="CARD">
                <label class="form-check-label" for="paymentCards">
                    <h3>Pago online</h3>
                    <img :src="require('@/assets/img/icon-payment-cards.png')">
                </label>
            </div>
        </div>
        
        
        <!-- <div class="payment-method">
            <div class="form-check">
                <input class="form-check-input" type="radio" name="paymentAbitab" id="paymentAbitab" v-model="payMethod" value="5">
                <label class="form-check-label" for="paymentAbitab">
                    <img :src="require('@/assets/img/icon-payment-abitab.png')">
                </label>
            </div>
        </div> -->
        
        <div class="payment-method" :class="{'unavailable':!offlinePayAvailable}">
            <div class="form-check">
                <input class="form-check-input" type="radio" name="paymentRedpagos" id="paymentRedpagos" v-model="payMethod" value="10" :disabled="!offlinePayAvailable">
                <label class="form-check-label" for="paymentRedpagos">
                    <h3>
                        Redes fisicas
                        <small class="text-danger d-block" v-if="!offlinePayAvailable">NO DISPONIBLE PARA RESERVAS CON MENOS DE 48 HORAS DE ANTICIPACIÓN</small>
                    </h3>
                    <img :src="require('@/assets/img/icon-payment-redpagos.png')">
                </label>
            </div>
        </div>

        <div class="payment-method" :class="{'unavailable':!offlinePayAvailable}">
            <div class="form-check">
                <input class="form-check-input" type="radio" name="paymentDebit" id="paymentDebit" v-model="payMethod" value="BANK" :disabled="!offlinePayAvailable">
                <label class="form-check-label" for="paymentDebit">
                    <h3>
                        Transferencia bancaria
                        <small class="text-danger d-block" v-if="!offlinePayAvailable">NO DISPONIBLE PARA RESERVAS CON MENOS DE 48 HORAS DE ANTICIPACIÓN</small>
                    </h3>
                    <img :src="require('@/assets/img/icon-payment-bank.png')">
                </label>
            </div>

            <!-- <div class="form-group" v-if="payMethod=='DEBIT'">
                <select class="form-control"  v-model="bankProcessor">
                    <option value="5" selected>e-BROU</option>
                    <option value="11" >Santander</option>
                    <option value="12" >BBVA</option>
                </select>
            </div> -->

        </div>

    </div>

    
    <!-- <form ref="PWRequestForm" method="POST" action="https://pagosweb.com.uy/v3.4/requestprocessor.aspx"   enctype="multipart/form-data" > -->
    <form ref="PWRequestForm" method="POST" :action="PAGOS_WEB_URL"   enctype="multipart/form-data" >
    </form>
    
   <input type="hidden" class="form-control" name="PWToken" id="PWToken" /> 
</div>

</template>

<script>
import gql from 'graphql-tag'
// import axios from 'axios';

export default {
	name: "Payment",
    props: ['amount', 'datetime'],
	data(){
		return{
            PAGOS_WEB_URL: process.env.VUE_APP_PAGOSWEB,
            payment:{
                name: 'Doctor Consultas',
                email: 'hello@doctorconsultas.com',
                image: 'https://doctorconsultas.com/img/logo-siemprepago.jpg',
                button_label: 'Pagar #monto#',
                description: 'Checkout',
                currency: 'UYU',
                amount: 0,
                lang: 'ESP',
                form_id: 'commerce_form',
                checkout_card: null,
                autoSubmit: true,
                email_edit: false,
                close_onclick:'false'
            },
            offlinePayLimit: this.$moment(new Date(), 'DD-MM-YYYY HH:mm').add(48, 'h'),
            offlinePayAvailable :true,
            payMethod: 'CARD',
            purchase: {},
            bankProcessor: 0,
            now: this.$moment(),
            paying: false,
		}
    },
    mounted(){
        
        this.payment.amount = this.amount;
        console.log(this.datetime, this.offlinePayLimit)
        //compruebo si estoy habilitado para pagar con debito.
        if ( this.datetime && (this.offlinePayLimit > this.$moment(this.datetime))) {
            this.offlinePayAvailable = false
            console.log('Faltan menos de 48 horas para la reserva.')
        }
        window.PWCheckout.Bind('tokenCreated', this.processPayment);
        window.PWCheckout.Bind('closed', this.closedCheckout);
    },
	methods:{
        closedCheckout(data){
            //verifico si el proceso sigue o se cancelo.
            console.log('payment closedCheckout', data)
            if(data.Reason == 'CLOSE_BUTTON') {
                this.paying = false
            }
            this.$emit('paymentClosed',this.paying);
        },
        validate(){
            let validate = {}
            validate.valid = true
            validate.err = ''
            if( this.payMethod == '5' || this.payMethod == '10' ){ // abitab y redpagos
            }
            if( this.payMethod == 'BANK' ){ // Pago por transferencia bancaria.

            }
            if( this.payMethod == 'CARD' ){ // plataforma siemprepago para tarjetas de credito
            }
            if( this.payMethod == 'DEBIT' ){ // pagosweb para bancos
                if( this.bankProcessor != 5 && this.bankProcessor != 11 && this.bankProcessor != 12 ) {
                    validate.valid = false
                    validate.err = 'Debe seleccionar una entidad bancaria'
                }
            }
            return validate;
        },
        proccess(purchase, selled){
            console.log('process ', purchase)
            this.payment.amount = this.amount;
            // this.loadBooking(bookId)
            this.paying = true;
            //se esta vendiendo una reserva
            this.purchase = purchase;
            
            
            if(selled == 'clinicService'){
                this.purchase.type = 'clinicService'
            }else{
                this.purchase.type = 'booking'
            }
            this.payment.email = this.purchase.user.email;
            this.getToken();
        },
        getToken(){
            console.log('selectPayMethod', this.payment, this.purchase, this.payMethod)
            if( this.payMethod == '5' || this.payMethod == '10' ){ // abitab y redpagos
                window.PWCheckout.GetCustomToken(this.payMethod,this.purchase.user.email, this.purchase.user.doc_number);
            }else if( this.payMethod == 'CARD' ){ // plataforma siemprepago para tarjetas de credito
                console.log('PWCheckout.SetProperties', this.payment)
                window.PWCheckout.SetProperties(this.payment); 
                window.PWCheckout.OpenIframeNormal(null,null);
            }else if( this.payMethod == 'DEBIT' ){ // plataforma pagos web para tarjetas de debito
                this.getPagoswebToken()
            }else if( this.payMethod == 'BANK' ){ // plataforma pagos web para tarjetas de debito
                this.processPaymentSimple(this.payMethod)
            }
        },
        getPagoswebToken(){
            console.log('getPagoswebToken')
            this.$apollo.mutate({
                mutation: gql`mutation ( $purchase_id:ID!, $payment_method: Int!, $purchase_type: String!){
                    getPagoswebToken( purchase_id: $purchase_id, payment_method: $payment_method, purchase_type: $purchase_type) {
                        token
                        request
                    }
                }`,
                variables: {
                    purchase_id: this.purchase.id,
                    payment_method: this.bankProcessor,
                    purchase_type: this.purchase.type,
                }
            })
            .then((data) => {
                let request = JSON.parse(data.data.getPagoswebToken.request)
                this.PWGenerateFormToSend(request)
            })
            .catch(error => {
                console.log(error);
                //this.paying = false;
                this.$emit('paymentDone',error);
            });
        },
        PWGenerateFormToSend(request){
            console.log('iFramePagosweb')
            
            let form = this.$refs.PWRequestForm
            for(var index in request) {
                let i = document.createElement("input");
                i.type = 'hidden'
                i.name = index
                i.value = request[index]
                form.appendChild(i)
            }
            this.$refs.PWRequestForm.submit()
        },
        processPayment(){
            console.log('processPayment')
            let dataInput = {
                trxToken: document.querySelector("input[id=PWToken]").value,
                purchase_id: this.purchase.id,
                purchase_type: this.purchase.type,
                amount: this.payment.amount,
            }
            
            this.$apollo.mutate({
                mutation: gql`mutation ( $data:PaymentInput! ){
                    bookingPayment( data: $data) {
                        code
                        purchaseId
                        transactionId
                        transactionStatusId
                        transactionStatus
                        customerId
                        returned
                    }
                }`,
                variables: {
                    data: dataInput,
                }
            })
            .then((data) => {
                console.log('processPayment Done ',data.data)
                if( data.data.bookingPayment.transactionStatusId == 1){
                    //Pago aprobado
                    this.paying = false;
                    this.$emit('paymentDone', this.purchase.code, data.data.bookingPayment);
                }
                if( data.data.bookingPayment.transactionStatusId == 2){
                    // Pago pendiente. para pagos fisicos.
                    this.paying = false;
                    console.log('emit paymentDone ', this.purchase.code, data.data.bookingPayment)    
                    this.$emit('paymentDone', this.purchase.code, data.data.bookingPayment);
                }
                if( data.data.bookingPayment.transactionStatusId == 3){
                    // Pago pre -authorizado
                    this.paying = false;
                    this.$emit('paymentDone', this.purchase.code, data.data.bookingPayment);
                }
                if( data.data.bookingPayment.transactionStatusId == 4){
                    // Pago rechazado
                    this.paying = false;
                    this.$emit('paymentDone', this.purchase.code, data.data.bookingPayment);
                }
            })
            .catch(error => {
                console.log(error);
                this.$emit('paymentDone',error);
            });
        },
        processPaymentSimple(payMethod){
            console.log('processPaymentBank', this.purchase)

            this.$apollo.mutate({
                mutation: gql`mutation ( $id:ID!, $serviceType:String!, $method:String! ){
                    bookingPaymentSimple( id: $id, serviceType: $serviceType,method: $method ) {
                        id
                    }
                }`,
                variables: {
                    id: this.purchase.id,
                    serviceType: this.purchase.type,
                    method: payMethod,
                }
            })
            .then((data) => {
                
                console.log('processPayment Done ',data.data)
                this.paying = false;
                this.$emit('paymentDone', this.purchase.code, data.data.bookingPaymentSimple);

            })
            .catch(error => {
                console.log(error);
                this.$emit('paymentDone',error);
            });
        },
    },
    
};
</script>

<style scoped>
h2{
    text-transform: uppercase;
    font-size: 12px;
}

.payment-methods{
    margin:12px 0px;
}
.payment-methods .payment-method{
    border-bottom: solid 1px #f3f3f3;
    display: flex;
    width:100%;
    flex-wrap: wrap;
}
.payment-methods .payment-method.unavailable{
    opacity: .7;
}

.payment-methods .payment-method .form-check{
    width: 100%;
}
.payment-methods .payment-method .form-check input{
    margin-top: 12px;
}
.payment-methods .payment-method .form-check label{
    padding: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
}
.payment-methods .payment-method .form-check label h3{
    font-size: 14px;
    flex-grow: 1;
    margin: 0px;
    text-transform: uppercase;
}

.payment-methods .payment-method img{
    height: 22px;
}
.payment-methods .payment-method .form-group{
margin-left: 28px;
    min-width: 200px;
}

</style>
